
/**
 * Utilitaire pour générer des schémas JSON-LD cohérents pour les outils
 */

export type ToolSchema = {
  name: string;
  description: string;
  applicationCategory?: string;
  featureList?: string[];
  keywords?: string[];
  additionalProperties?: Record<string, any>;
}

/**
 * Génère un schéma JSON-LD standard pour les outils
 * 
 * @param tool Les informations sur l'outil
 * @returns Un schéma JSON-LD pour l'outil
 */
export const generateToolSchema = (tool: ToolSchema) => {
  // Déterminer la catégorie d'application en fonction du nom de l'outil
  let category = tool.applicationCategory || "WebApplication";
  
  // S'assurer que la catégorie se termine par "Application" si ce n'est pas déjà le cas
  if (!category.endsWith("Application") && !category.endsWith("Tool")) {
    category = `${category}Tool`;
  }

  // Créer le schéma de base
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": `${tool.name} - AlunaTools`,
    "description": tool.description,
    "applicationCategory": category,
    "operatingSystem": "Web Browser",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "EUR"
    }
  };

  // Ajouter des propriétés facultatives si elles sont fournies
  if (tool.featureList && tool.featureList.length > 0) {
    Object.assign(schema, { "featureList": tool.featureList });
  }

  if (tool.keywords && tool.keywords.length > 0) {
    Object.assign(schema, { "keywords": tool.keywords.join(", ") });
  }

  // Ajouter des propriétés supplémentaires si elles sont fournies
  if (tool.additionalProperties) {
    Object.assign(schema, tool.additionalProperties);
  }

  return schema;
};

/**
 * Map des catégories d'application pour différents types d'outils
 */
export const TOOL_CATEGORIES = {
  MARKETING: "MarketingApplication",
  BUSINESS: "BusinessApplication",
  SEO: "SEOApplication",
  PRODUCTIVITY: "ProductivityApplication",
  UTILITY: "UtilityApplication",
  DESIGN: "DesignApplication",
  COMMUNICATION: "CommunicationApplication",
  ANALYTICS: "AnalyticsApplication"
};
